import tileInformation from './tileInformation.json';

export const TILE_ENTITY_OPTIONS = Object.keys(tileInformation).map((key) => ({
  key,
  label: tileInformation[key].niceName || key,
}));

export const MAP_LAYER_OPTIONS = [
  { key: 'baseGrid', label: 'Base Grid' },
  { key: 'territory', label: 'Territory' },
  { key: 'drawings', label: 'Drawings' },
  ...TILE_ENTITY_OPTIONS,
];

export const getBaseTileType = (type = '') => type.replace(/-child$/, '');
